import React, { useEffect, type PropsWithChildren } from 'react';
import { LocalStorageKey } from '@cg/constants/LocalStorageKey';

export const LandingUrlSetter: React.FC<PropsWithChildren> = ({ children }) => {
  useEffect(() => {
    if (!localStorage.getItem(LocalStorageKey.SIGNUP_SOURCE)) {
      localStorage.setItem(LocalStorageKey.SIGNUP_SOURCE, window.location.href);
    }
  }, []);

  return <>{children}</>;
};

export default LandingUrlSetter;
